import React from 'react';

import { SystemState } from './SystemState';


/**
 * Site-branded 404 page wired as the root route `notFoundComponent`
 * (see `routes/__root.jsx`), so any unmatched path renders a standalone,
 * full-viewport page rather than a bare stub.
 *
 * Now a thin wrapper over the parametrized `SystemState` (AUTOORBIT-419), which
 * carries the shared brand lockup + centered card and the auth-aware CTA. The
 * `NotFound` export is preserved so existing importers keep compiling.
 */
const NotFound = React.forwardRef((props, ref) => (
  <SystemState ref={ref} status={404} {...props} />
));

NotFound.displayName = 'NotFound';

export { NotFound };
export default NotFound;
